<!--  -->
<template>
  <div class="header">
    <div class="header__left">
      <div class="header__logo">
        <img class="logo-pc" src="../../assets/images/home/home-logo.png" />
      </div>
      <ul class="header__nav">
        <li class="header__nav__item">
          P2P
        </li>
        <li class="header__nav__item" @click="handleClick(`${host}trade`)">
          Exchange
        </li>
        <li class="header__nav__item" @click="handleClick(`${host}trade`)">
          {{ $t('headerNew.broker') }}
        </li>
        <li class="header__nav__item" @click="handleClick(`${host}app-download`)">
          {{ $t('headerNew.appDownLoad') }}
        </li>
      </ul>
    </div>
    <div class="header__right">
      <template v-if="!isLogin">
        <div class="header__login" @click="handleLogin">
          {{ $t('headerNew.login') }}
        </div>
        <div class="header__sign-up" @click="handleRegister">
          {{ $t('headerNew.register') }}
        </div>
      </template>
      <template v-else>
        <div class="header__wallet" @click="handleClick(`${host}assets/ex-account`)">
          {{ $t('headerNew.assets') }}
        </div>
        <div class="header__order" @click="handleClick(`${host}order/ex-order`)">
          {{ $t('headerNew.order') }}
        </div>
        <div class="header__message"  @click="handleClick(`${host}message`)">
          <div class="header-icon">
            <svg class="icon icon-18" aria-hidden="true">
              <use xlink:href="#icon-b_3"></use>
            </svg>
          </div>
          <div class="header-icon--active">
            <svg class="icon icon-18" aria-hidden="true">
              <use xlink:href="#icon-b_3_1"></use>
            </svg>
          </div>
        </div>
        <div class="header__user" @click="handleClick(`${host}personal/user-account`)">
          <div class="header-icon">
            <svg class="icon icon-18" aria-hidden="true">
              <use xlink:href="#icon-b_4"></use>
            </svg>
          </div>
          <div class="header-icon--active">
            <svg class="icon icon-18" aria-hidden="true">
              <use xlink:href="#icon-b_4_1"></use>
            </svg>
          </div>
          <div class="header__user__box">
            <div class="header__user__account" >
              {{ userText }}
            </div>
            <div class="header__user__desc">
              {{ $t('headerNew.userStatus') }}：{{ userStatus }}
            </div>
            <div class="header__user__logout" @click="logOut">
              {{ $t('headerNew.out') }}
            </div>
          </div>
        </div>
      </template>
      <div class="header__language">
        <div class="header__language__con">
          {{showLan}}
          <svg class="icon icon-14" aria-hidden="true">
            <use xlink:href="#icon-a_13"></use>
          </svg>
        </div>
        <div class="header__language__pop">
          <div
            class="header__language__list"
            :class="lan === item.id ? 'langActive' : ''"
            v-for="item in langArr"
            :key="item.id"
            @click="lanClick(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  setCookie,
} from '@/utils';

export default {
  data() {
    return {
      langArr: [
        { name: 'English', id: 'en_US' },
        { name: 'عربي', id: 'ar_SA' },
        // { name: '简体中文', id: 'zh_CN' },
      ],
      host: process.env.VUE_APP_COMPILE_ENV === 'prod' ? 'https://mal.io/' : 'https://test.mal.coffee:8734/',
    };
  },
  props: {},
  components: {},
  computed: {
    userInfo() {
      return this.$store.state.baseData.userInfo || {};
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    userText() {
      if (this.userInfo) {
        return this.userInfo.userAccount;
      }
      return '';
    },
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    userStatus() {
      let str = '';
      if (this.userInfo && this.userInfo.accountStatus.toString()) {
        switch (this.userInfo.accountStatus.toString()) {
          case '0':
            str = this.$t('headerNew.userStatus1'); // '正常';
            break;
          case '1':
            str = this.$t('headerNew.userStatus2'); // '冻结交易，冻结提现';
            break;
          case '2':
            str = this.$t('headerNew.userStatus3'); // '冻结交易 3冻结提现';
            break;
          default:
            break;
        }
      }
      return str;
    },
    tradesList() {
      const arr = [];
      // 币币交易
      if (this.headerLink.trade) {
        arr.push({
          title: this.$t('header.trade'),
          activeId: 'exTrade',
          link: this.headerLink.trade,
        });
      }
      // 法币
      if (this.headerLink.fiat) {
        arr.push({
          title: this.$t('header.fiat'),
          activeId: 'fiatTrade',
          link: this.fiatUrl,
          target: 'blank',
        });
      }
      // 场外
      if (this.headerLink.otc) {
        arr.push({
          title: this.$t('header.otc'),
          activeId: 'otcTrade',
          link: this.headerLink.otc,
        });
      }
      // 合约
      if (this.headerLink.co) {
        arr.push({
          title: this.$t('header.co'),
          activeId: 'coTrade',
          link: this.headerLink.co,
        });
      }
      // 杠杆
      if (this.leverFlag) {
        arr.push({
          title: this.$t('header.lever'),
          activeId: 'marginTrade',
          link: this.headerLink.lever,
        });
      }
      return arr;
    },
    linkurl() {
      if (this.$store.state.baseData.publicInfo) {
        return this.$store.state.baseData.publicInfo.url;
      }
      return {};
    },
    headerLink() {
      if (process.env.NODE_ENV === 'development') {
        return {
          home: '/ex/',
          trade: this.linkurl.exUrl ? '/ex/trade' : '',
          // lever: '/ex/margin',
          // otc: this.linkurl.otcUrl ? '/otc/' : '',
          // co: this.linkurl.coUrl ? '/co/trade' : '',
          fiat: process.env.VUE_APP_FIAT_URL,
        };
      }
      if (this.$store.state.baseData && this.$store.state.baseData.publicInfo) {
        return {
          home: this.linkurl.exUrl,
          trade: this.linkurl.exUrl ? `${this.linkurl.exUrl}/trade` : '',
          // otc: this.linkurl.otcUrl,
          // lever: this.linkurl.exUrl ? `${this.linkurl.exUrl}/margin` : '',
          // co: this.linkurl.coUrl,
          fiat: this.linkurl.motcUrl ? this.linkurl.motcUrl : process.env.VUE_APP_FIAT_URL,
        };
      }
      return '';
    },
    lan() {
      if (this.isLogin && this.$store.state.baseData && this.$store.state.baseData.lan) {
        console.log('lang', this.$store.state.baseData.lan);
        return this.$store.state.baseData.lan;
      }
      return this.$i18n.locale;
    },
    showLan() {
      let str = '';
      if (this.langArr.length) {
        this.langArr.forEach((item) => {
          if (this.lan === item.id) {
            str = item.name;
          }
        });
      }
      return str;
    },
  },
  created() {},
  mounted() {
    const locale = localStorage.getItem('locale');
    if (locale === 'ar_SA') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  },
  methods: {
    handleLogin() {
      // window.location.href = `https://mal.io/login?redirect=${window.location.href}`;
      const currentHost = process.env.VUE_APP_COMPILE_ENV === 'prod' ? 'https://mal.io/' : 'https://test.mal.coffee:8734/';
      window.location.href = `${currentHost}login?redirect=${window.location.href}`;
    },
    handleRegister() {
      const currentHost = process.env.VUE_APP_COMPILE_ENV === 'prod' ? 'https://mal.io/' : 'https://test.mal.coffee:8734/';
      window.location.href = `${currentHost}register`;
    },
    handleClick(url) {
      window.location.href = url;
    },
    lanClick(id) {
      // this.
      if (id === this.lan) {
        return;
      }
      // 如果是登录用户，调接口切换语言
      // if (this.isLogin) {
      this.axios({
        url: this.$store.state.url.common.change_language,
        params: { language: id },
        method: 'post',
      }).then((res) => {
        if (Number(res.code) === 0) {
          console.log('切换成功');
        }
        // const lang = id === 'zh_CN' ? 'ar_SA' : 'en_US';
        localStorage.setItem('locale', id);
        setCookie('lan', id);
        console.log('id', id);
        if (id === 'ar_SA') {
          document.documentElement.dir = 'rtl';
        } else {
          document.documentElement.dir = 'ltr';
        }
        // this.$i18n.locale = id;
        // 这里直接刷新页面，因为有些内容的多语言配置是通过接口获取的
        // 比如：公共底部
        window.location.reload();
      });
      // }
    },
    logOut() {
      if (!this.outFlag) {
        return;
      }
      this.outFlag = false;
      this.axios({
        url: 'user/login_out',
      }).then((data) => {
        this.outFlag = true;
        if (data.code.toString() === '0') {
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.$bus.$emit('outUserIsLogin');
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.header {
  min-width: 1202px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  padding-left: 30px;
  background: #151620;

  &__left,
  &__right {
    flex: 1;
    height: 60px;
    display: flex;
    align-items: center;
  }

  &__right {
    justify-content: flex-end;
  }

  &__logo {
    width: 99px;
    height: 30px;
    margin-right: 72px;

    >img {
      width: 100%;
      height: 100%;
    }
  }

  &__nav {
    display: flex;
    flex-wrap: nowrap;

    &__item {
      margin-right: 48px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  &__language {
    height: 60px;
    position: relative;
    cursor: pointer;

    &__con {
      width: 120px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__pop {
      position: absolute;
      top: 60px;
      right: 0;
      display: none;
      z-index: 200;
      background: #191f2b;
    }

    &__list {
      width: 200px;
      height: 50px;
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background: #252e3f;
      }
    }

    .langActive {
      background: #252e3f;
    }

    &:hover {
      .header__language__pop {
        display: block;
      }
    }
  }

  &__login,
  &__wallet,
  &__order {
    line-height: 60px;
    margin-right: 30px;
    cursor: pointer;
  }

  &__message,
  &__user {
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 20px;
    position: relative;
    z-index: 200;

    .header-icon {
      display: block;
    }

    .header-icon--active {
      display: none;
    }

    &:hover {
      >.header-icon {
        display: none;
      }

      >.header-icon--active {
        display: block;
      }

      .header__user__box {
        display: block;
      }
    }
  }

  &__user {
    position: relative;
    &__box {
      width: 240px;
      height: 120px;
      background: #191f2b;
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      display: none;
      box-sizing: border-box;
      padding: 20px;
    }

    &__account {
      font-size: 14px;
      color: #edf4f8;
    }

    &__desc {
      font-size: 12px;
      color: #828ea1;
      margin-top: 10px;
    }

    &__logout {
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      background: #252e3f;
      text-align: center;
      margin-top: 20px;
    }

  }

  &__sign-up {
    padding: 0 22px;
    border-radius: 4px;
    background: #00a150;
    border: none;
    height: 30px;
    line-height: 30px;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 0px;
    color: #000;
    margin-right: 30px;
    cursor: pointer;
  }
}
</style>
